import { BaseReducerState} from '../../../services'
import { ActionTypes } from './actions'
import {SiteStock, SitesStockSummaryAPIResponse } from './types'

export type SitesStockSummaryState = BaseReducerState & {
  data: [SiteStock]
}

export const initialState: SitesStockSummaryState = {
  loading: false,
  success: false,
  message: '',
  data: null,
  error: null,
}

export const sitesStockSummaryState = (
  state: SitesStockSummaryState = initialState,
  action: { type: string; res: any }
): SitesStockSummaryState => {
  switch (action.type) {
    case `${ActionTypes.GET_SITES_STOCK_SUMMARY_DATA}_REQUEST`:
      return {
        ...state,
        loading: true,
        success: false,
        message: null,
        data: null,
        error: null,
      }

    case `${ActionTypes.GET_SITES_STOCK_SUMMARY_DATA}_SUCCESS`: {
      const { success, data, message } = <SitesStockSummaryAPIResponse>action.res
      return {
        ...state,
        loading: false,
        success,
        message,
        ...(success && data && { data }),
      }
    }
    case `${ActionTypes.GET_SITES_STOCK_SUMMARY_DATA}_FAILURE`:
      const res = <SitesStockSummaryAPIResponse>action.res
      const { message } = res || {}
      res.error ??= message
      const { error } = res
      return {
        ...state,
        loading: false,
        success: false,
        message,
        error,
      }

    case `${ActionTypes.GET_SITES_STOCK_SUMMARY_DATA}_RESET`:
      return {
        ...initialState,
      }
  }
  return state
}
